<!--Basic Pagination Starts-->
<section id="basic-pagination">
    <div class="row text-left">
        <div class="col-sm-12">
            <div class="content-header">Pagination</div>
            <p class="content-sub-header">Provide pagination links for your site or app with the multi-page pagination component, or the simpler pager alternative.</p>
        </div>
    </div>
    <div class="row text-left" matchHeight ="card">
        <!--Basic Pagination Starts-->
        <div class="col-xl-6 col-lg-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Basic Pagination</h4>
                </div>
                <div class="card-content">
                    <div class="card-body">
                        <h5 class="mb-2 mt-4 text-bold-400">Default pagination</h5>
                        <ngb-pagination [collectionSize]="70" [(page)]="page"></ngb-pagination>
                        <h5 class="mb-2 mt-4 text-bold-400">directionLinks = false</h5>
                        <ngb-pagination [collectionSize]="70" [(page)]="page1" [directionLinks]="false"></ngb-pagination>
                        <h5 class="mb-2 mt-4 text-bold-400">boundaryLinks = true</h5>
                        <ngb-pagination [collectionSize]="70" [(page)]="page2" [boundaryLinks]="true"></ngb-pagination>
                        <hr>
                        <p>Current page: {{page2}}</p>
                    </div>
                </div>
            </div>
        </div>
        <!--Basic Pagination Ends-->

        <!--Advanced Pagination Starts-->
        <div class="col-xl-6 col-lg-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Advanced Pagination</h4>
                </div>
                <div class="card-content">
                    <div class="card-body">
                        <h5 class="mb-2 mt-4 text-bold-400">maxSize = 5, rotate = false</h5>
                        <ngb-pagination [collectionSize]="120" [(page)]="page3" [maxSize]="5" [boundaryLinks]="true"></ngb-pagination>
                        <h5 class="mb-2 mt-4 text-bold-400">maxSize = 5, rotate = true</h5>
                        <ngb-pagination [collectionSize]="120" [(page)]="page4" [maxSize]="5" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
                        <h5 class="mb-2 mt-4 text-bold-400">maxSize = 5, rotate = true, ellipses = false</h5>
                        <ngb-pagination [collectionSize]="120" [(page)]="page5" [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="true"></ngb-pagination>
                        <hr>
                        <p>Current page: {{page5}}</p>
                    </div>
                </div>
            </div>
        </div>
        <!--Advanced Pagination Ends-->
    </div>
</section>
<section id="pagination-option">
    <div class="row text-left" matchHeight ="card">
        <!--Pagination Sizes Starts-->
        <div class="col-xl-6 col-lg-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Pagination Sizes</h4>
                </div>
                <div class="card-content">
                    <div class="card-body">
                        <h5 class="mb-2 mt-4 text-bold-400">Large Pagination</h5>
                        <ngb-pagination [collectionSize]="30" [(page)]="currentPage" size="lg"></ngb-pagination>
                        <h5 class="mb-2 mt-4 text-bold-400">Default Pagination</h5>
                        <ngb-pagination [collectionSize]="30" [(page)]="currentPage1"></ngb-pagination>
                        <h5 class="mb-2 mt-4 text-bold-400">Small Pagination</h5>
                        <ngb-pagination [collectionSize]="30" [(page)]="currentPage2" size="sm"></ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!--Pagination Sizes Ends-->

        <!--Pagination Options Starts-->
        <div class="col-xl-6 col-lg-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Pagination Options</h4>
                </div>
                <div class="card-content">
                    <div class="card-body">
                        <h5 class="mb-2 mt-4 text-bold-400">Pagination control can be disabled</h5>
                        <ngb-pagination [collectionSize]="70" [(page)]="page6" [disabled]='isDisabled'></ngb-pagination>
                        <button class="btn btn-sm btn-outline-primary" (click)="toggleDisabled()">
                            Toggle disabled
                        </button>
                        
                        <h5 class="mb-2 mt-4 text-bold-400">This pagination uses custom default values</h5>
                        <ngb-pagination [collectionSize]="70" [(page)]="page7"></ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!--Pagination Options Ends-->
    </div>
</section>
<!--Basic Pagination Ends-->